import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import moment from "moment";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import InputPicker from "../../components/common/InputPicker";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorRepresentante_Ex,initDataProveedorRepresentanteArray_Ex,
  initDataProveedorRepresentante_Val,initDataProveedorRepresentanteArray_Val,
  initDataProveedorGrupoEconomico_Ex,initDataProveedorGrupoEconomicoArray_Ex,
  initDataProveedorGrupoEconomico_Val,initDataProveedorGrupoEconomicoArray_Val} from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import editUserIcon from "../../assets/gl_edit_16.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
//import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Checkbox from "../../components/common/Checkbox";
import Validate from "../../utils/Validate";

const ProveedoresRepresentanteLegal = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setarrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [arrTipoDoce, setArrTipoDoce] = useState([]);
  const [arrMoneda , setArrMoneda] = useState([]);
  const [dataTemp, setDataTemp] = useState({});
  const [dataTempGr, setDataTempGr] = useState({});
  const [validacionTemp, setValidacionTemp] = useState({});
  const [validacionTempGr, setValidacionTempGr] = useState({});
  const [infoModal, setInfoModal] = useState(null);
  const [data, setData] = useState({indGrupoEconomico: dataT.indGrupoEconomico, representante:Validate.extraerAtributos(initDataProveedorRepresentante_Ex, dataT, initDataProveedorRepresentanteArray_Ex).representante, 
                                    grupoEconomico:Validate.extraerAtributos(initDataProveedorGrupoEconomico_Ex, dataT, initDataProveedorGrupoEconomicoArray_Ex).grupoEconomico});
  const [validacion, setValidacion] = useState({grupoEconomico:[], representante:[]});
  const [indiceEditar, setIndiceEditar] = useState(null);
  const [indiceEditarGr, setIndiceEditarGr] = useState(null);
  useEffect(() => {    
    setData({indGrupoEconomico: dataT.indGrupoEconomico, representante:Validate.extraerAtributos(initDataProveedorRepresentante_Ex, dataT, initDataProveedorRepresentanteArray_Ex).representante, 
      grupoEconomico:Validate.extraerAtributos(initDataProveedorGrupoEconomico_Ex, dataT, initDataProveedorGrupoEconomicoArray_Ex).grupoEconomico});
  }, [dataT]);
  useEffect(() => {    
    getMonedas();
    getTipoDoc();
    getPaises();
    getTipoDoce();
  }, []);
  let arrSN=[{value:'S',text:'SI'},{value:'N',text:'NO'}];
  const getMonedas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','MONEDA'));
      if (response.ok && response.data && response.data.payload) {
        let monedas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrMoneda(monedas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };
  const getTipoDoc = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const getTipoDoce = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOCE'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoce = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoce(tipdoce);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const getPaises = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarPaises);
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.idpais,
            text: el.descpais
          };
        });
        setArrPais(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getPaises", ex);
    }
  };
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      //let limpArr = Validate.limpiarArregloIdProveedor(value.map((obj) => Object.assign({},obj)));
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const handleChangeTemp = (name, value) => {    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setDataTemp({ ...dataTemp, [name]: value });
    setValidacionTemp({ ...validacionTemp, [name]: false });
  };
  const handleChangeTempGr = (name, value) => {    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setDataTempGr({ ...dataTempGr, [name]: value });
    setValidacionTempGr({ ...validacionTempGr, [name]: false });
  };
  const validarFormulario = () => {
    let resp = true;    
    if(dataTemp.indPep=='N'){
      delete initDataProveedorRepresentanteArray_Val.cargo;
      delete initDataProveedorRepresentanteArray_Val.aniosCargo;
    }else{
      initDataProveedorRepresentanteArray_Val.cargo= "";
      initDataProveedorRepresentanteArray_Val.aniosCargo= "";
    }
    for (var name in Object.assign({},initDataProveedorRepresentanteArray_Val,Validate.limpiarObjeto(dataTemp))) {
      //if (data.hasOwnProperty(name)){
        if(!dataTemp[name] ){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
          //break;
        }
        if(name=='correo' && !Validate.validarEmail(dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        } 
        if(name=='numeroDocumento' && !Validate.validarDocumento(dataTemp.idpTipoDocumento,dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        }
        if(name=='prcCapital' && !Validate.validarPorcentaje(dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        } 
      //}     
    }
    return resp;
  }
  const validarFormularioGr = () => {
    let resp = true;    
    for (var name in Object.assign({},initDataProveedorGrupoEconomicoArray_Val,Validate.limpiarObjeto(dataTempGr))) {
      //if (data.hasOwnProperty(name)){
        if(!dataTempGr[name] ){
          validacionTempGr[name] = true;
          setValidacionTempGr({...validacionTempGr, [name]: true});
          resp = false;
          //break;
        }
        if(name=='correo' && !Validate.validarEmail(dataTempGr[name])){
          validacionTempGr[name] = true;
          setValidacionTempGr({...validacionTempGr, [name]: true});
          resp = false;
        } 
        if(name=='numeroDocumento' && !Validate.validarDocumento(dataTempGr.idpTipoDocumento,dataTempGr[name])){
          validacionTempGr[name] = true;
          setValidacionTempGr({...validacionTempGr, [name]: true});
          resp = false;
        }
        if(name=='prcCapital' && !Validate.validarPorcentaje(dataTempGr[name])){
          validacionTempGr[name] = true;
          setValidacionTempGr({...validacionTempGr, [name]: true});
          resp = false;
        } 
      //}     
    }
    return resp;
  }
  const validarFormularioGeneral = () => {
    let resp = true;
    for (var name in Object.assign({},{indGrupoEconomico:'', representante: [], grupoEconomico: []},Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }        
        if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            if(elem.prcCapital)
              elem.prcCapital=Number(elem.prcCapital);
            if(elem.aniosCargo)
              elem.aniosCargo=Number(elem.aniosCargo);
          }
        }           
    }
    return resp;
  }
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 
  const handleEditarRepresentante = (obj,i) => {    
      setInfoModal(false);
      if(obj.prcCapital)
        obj.prcCapital=Number(obj.prcCapital);
      if(obj.aniosCargo)
        obj.aniosCargo=Number(obj.aniosCargo);
      setDataTemp(obj);
      setIndiceEditar(i);
  };
  const handleEditarGrupoEconomico = (obj,i) => {    
    setInfoModal(false);
    if(obj.prcCapital)
      obj.prcCapital=Number(obj.prcCapital);
    if(obj.aniosCargo)
      obj.aniosCargo=Number(obj.aniosCargo);
    setDataTempGr(obj);
    setIndiceEditarGr(i);
};
  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (tag) => {
    setTagBody(tag);
    setInfoModal(true);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModal = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">{tag=='PEP'?'PEP (Persona Expuesta Politicamente)':'Informacion'}</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-07 margin-bottom-10 text-justify">
            {tag=='PEP'?`Personas naturales, nacionales o extranjeras, que cumplen o que en los 
             últimos cinco (5) años hayan cumplido funciones públicas destacadas o funciones prominentes
              en una organizacion internacional, sea en el territorio nacional o extranjero. Asimismo, 
              en caso sea el colaborador directo de la máxima autoridad de la institución. Ejemplo: 
              Congresistas, Ministros, Alcaldes, etc.`:''}
            
          </h4>
        </div>
      </div>
    );
  };
  const bodyModalRepresentante = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10"><b>Representantes</b></h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          {data && data.representante && data.representante.length == 0 && (
            <div>No existen representantes.</div>
          )}
          {data.representante.map((obj,i)=>(
            <div className="rd--file-card padding-20">
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos3">
                      <label>
                      <span className="title-06">
                        <b>{obj.idpTipoDocumento}: </b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.numeroDocumento}
                      </span>
                      </label>
                </div>
                <div className="documents_criteria_datos4">
                  <Button
                    className="padding-5"
                    size="small"
                    iconLeft={
                      <img
                        src={editUserIcon}
                        alt="edit user logo"
                        height={15}
                        className="margin-right-8"
                      />
                    }
                    onClick={() => handleEditarRepresentante(obj, i)}
                  >
                    Editar
                  </Button>
                </div> 
              </div>
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nombre o Razón Social: </b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.nombres} 
                      </span>
                      </label>
                </div>
                { obj.indPep && 
                  <div className="documents_criteria_datosmod">
                    <label>
                    <span className="title-06">
                      <b>PEP:</b>
                    </span>
                    <span className="title-06 title-lower">
                      {obj.indPep=='S'?'SI':'NO'}
                    </span>
                    </label>
                  </div>
                }
                { obj.prcCapital && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>% Capital:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.prcCapital}
                      </span>
                      </label>
                </div>
                }
                { obj.cargo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Cargo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.cargo}
                      </span>
                      </label>
                </div>
                }
                { obj.aniosCargo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Años en que ejercio el cargo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.aniosCargo}
                      </span> 
                      </label>
                </div>
                }
                { obj.fecNacimiento && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Fecha de Nacimiento:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.fecNacimiento}
                      </span>
                      </label>
                </div>
                }
                { obj.profesion && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Ocupación:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.profesion}
                      </span>
                      </label>
                </div>
                }
                { obj.idPais && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nacionalidad:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {(arrPais && arrPais.length>0 && arrPais.find(el=>el.value==obj.idPais))?.text} 
                      </span>
                      </label>
                </div>
                }
                { obj.idResPais && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>País de Residencia:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {(arrPais && arrPais.length>0 && arrPais.find(el=>el.value==obj.idResPais))?.text} 
                      </span>
                      </label>
                </div>
                }
                { obj.direccion && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Dirección:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.direccion}
                      </span>
                      </label>
                </div>
                }
                { obj.telefono && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Teléfono:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.telefono}
                      </span> 
                      </label>
                </div>
                }
                { obj.correo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Correo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.correo}
                      </span>
                      </label>
                </div>
                }                
            </div>
          ))}
        </div>
      </div>
    );
  };
  const bodyModalGrupoEconomico = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10"><b>Grupo Económico</b></h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          {data && data.grupoEconomico && data.grupoEconomico.length == 0 && (
            <div>No existen Grupos económicos.</div>
          )}
          {data.grupoEconomico.map((obj,i)=>(
            <div className="rd--file-card padding-20">
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_datos3">
                        <label>
                        <span className="title-06">
                          <b>{obj.idpTipoDocumento}: </b>
                        </span>
                        <span className="title-06 title-lower">
                          {obj.numeroDocumento}
                        </span>
                        </label>
                  </div>
                  <div className="documents_criteria_datos4">
                    <Button
                      className="padding-5"
                      size="small"
                      iconLeft={
                        <img
                          src={editUserIcon}
                          alt="edit user logo"
                          height={15}
                          className="margin-right-8"
                        />
                      }
                      onClick={() => handleEditarGrupoEconomico(obj, i)}
                    >
                      Editar
                    </Button>
                  </div> 
                </div>
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nombre o Razón Social: </b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.nombres} 
                      </span>
                      </label>
                </div>
                { obj.idPais && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nacionalidad:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {(arrPais && arrPais.length>0 && arrPais.find(el=>el.value==obj.idPais))?.text} 
                      </span>
                      </label>
                </div>
                }
            </div>
          ))}
        </div>
      </div>
    );
  };
    

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
        <div className="proveedores_content">
            <h4 className="title-05 margin-bottom-16 margin-top-16">
                <b>Ingresa los <span class="title-red">Representantes legales:</span></b>
            </h4>
            <br/>
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_datos">
                      <InputWithDropdown
                        selectProps={{
                          label: "Tipo Documento",
                          selected: dataTemp && arrTipoDoc.find(obj=>obj.value==dataTemp.idpTipoDocumento),
                          onChange: (newValue) =>
                            handleChangeTemp("idpTipoDocumento",  newValue.value),
                          items: arrTipoDoc,
                          classNameList: 'listLarge',
                          hasError: validacionTemp.idpTipoDocumento && '*'
                        }}
                        inputProps={{
                          label: "Numero de Documento",
                          name: "numeroDocumento",
                          maxLength: "15",
                          value: dataTemp?.numeroDocumento,
                          customRegex: /^[a-zA-Z0-9]*$/,
                          onChange: (newValue) =>
                            handleChangeTemp("numeroDocumento", String(newValue)),
                          hasError: validacionTemp.numeroDocumento && '*'                          
                        }}
                      />
                  </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_datos">
                      <Input
                        label="Nombre Completo o Razón Social"
                        name="nombres"
                        maxLength="500"
                        value={dataTemp?.nombres}
                        onChange={(newValue) => {
                          handleChangeTemp("nombres", newValue); 
                        }                        
                        }
                        hasError= {validacionTemp.nombres && '*'}
                        customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                      
                      />
                  </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">
                    <div className="documents_criteria_datos">
                        <Select
                          label="PEP"
                          selected={dataTemp && arrSN.find(obj=>obj.value==dataTemp.indPep)}
                          onChange={(newValue) => {handleChangeTemp("indPep", newValue.value);
                                                  }}
                          items={arrSN}
                          filterable = {true}
                          hasError= {validacionTemp.indPep && '*'}
                        />
                    </div>
                </div>
                
                    {dataTemp.indPep=='S' && 
                      <div className="d-justify-space-between d-flex-column-m w100">
                        <div className="documents_criteria_datos2">
                            <Input
                              label="Cargo"
                              name="cargo"
                              maxLength="500"
                              value={dataTemp?.cargo}
                              onChange={(newValue) => {
                                handleChangeTemp("cargo", newValue); 
                              }
                              }
                              hasError= {validacionTemp.cargo && '*'}
                              customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                        
                            />
                        </div>
                        <div className="documents_criteria_datos2">
                            <Input
                              label="Años en los que ejercio el cargo (indicar si sigue teniendo el cargo)"
                              name="aniosCargo"
                              maxLength="4"
                              value={dataTemp?.aniosCargo}
                              onChange={(newValue) => {
                                handleChangeTemp("aniosCargo", Number(newValue)); 
                              }
                              }
                              hasError= {validacionTemp.aniosCargo && '*'}
                              customRegex={/^[0-9]*$/}
                            />
                        </div>
                      </div>
                    }                    
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <InputPicker
                        label="Fecha Nacimiento"
                        // value={data?.initDate}
                        value={dataTemp?.fecNacimiento ? (moment(dataTemp.fecNacimiento,"DD-MM-YYYY").toDate()):(undefined)}
                        onChange={(objDate) => handleChangeTemp("fecNacimiento", objDate.value?moment(objDate.value).format("DD-MM-YYYY"):'')}
                        maxDate={new Date()}
                        hasError= {validacionTemp.fecNacimiento && '*'}
                      />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Ocupación/Profesión"
                            name="profesion"
                            maxLength="1000"
                            value={dataTemp?.profesion}
                            onChange={(newValue) => {
                              handleChangeTemp("profesion", newValue); 
                            }
                            }
                            hasError= {validacionTemp.profesion && '*'}
                            customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                      
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <Select
                          label="Nacionalidad"
                          selected={dataTemp && arrPais.find(obj=>obj.value==dataTemp.idPais)}
                          onChange={(newValue) => {handleChangeTemp("idPais", newValue.value);
                                                  }}
                          items={arrPais}
                          filterable = {true}
                          hasError= {validacionTemp.idPais && '*'}
                        />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <Select
                          label="País de Residencia"
                          selected={dataTemp && arrPais.find(obj=>obj.value==dataTemp.idResPais)}
                          onChange={(newValue) => {handleChangeTemp("idResPais", newValue.value);
                                                  }}
                          items={arrPais}
                          filterable = {true}
                          hasError= {validacionTemp.idResPais && '*'}
                        />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Dirección"
                            name="direccion"
                            maxLength="500"
                            value={dataTemp?.direccion}
                            onChange={(newValue) => {
                              handleChangeTemp("direccion", newValue); 
                            }
                            }
                            hasError= {validacionTemp.direccion && '*'}
                            customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                        
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Teléfono"
                            name="telefono"
                            maxLength="15"
                            value={dataTemp?.telefono}
                            onChange={(newValue) => {
                              handleChangeTemp("telefono", newValue); 
                            }
                            }
                            hasError= {validacionTemp.telefono && '*'}
                            customRegex={/^[0-9]*$/}                        
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Correo"
                            name="correo"
                            maxLength="1000"
                            value={dataTemp?.correo}
                            onChange={(newValue) => {
                              handleChangeTemp("correo", newValue); 
                            }
                            }
                            hasError= {validacionTemp.correo && '*'}
                            customRegex={/^[a-zA-Z0-9\.\-\_@\.]*$/}                        
                          />
                      </div>
                    </div>
                            
                
                <div className="d-flex-center w100">
                  <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                    <div className="documents_btnSearch">
                      <Button
                        // type="submit"
                        primary
                        size="small"
                        onClick={()=>
                                {if(validarFormulario())
                                  { if(indiceEditar==null || indiceEditar==undefined){
                                      data.representante.push(dataTemp);
                                    }else{
                                      data.representante[indiceEditar]=dataTemp;
                                    }
                                    setIndiceEditar(null);                                   
                                    setDataTemp({});
                                    handleChange("representante", data.representante,data.representante.length-1 ); 
                                  }
                                }
                        }
                      >
                        Agregar Representante
                      </Button>
                    </div>                  
                  </div>
                </div>


            <div className="d-justify-space-between d-flex-column-m w100 text-justify margin-bottom-10">              
              <div className="documents_criteria_datos">
                <p><b>¿Pertenece a un grupo económico?</b></p>
                <Radio
                    id="indGrupoEconomico"
                    name="indGrupoEconomico"
                    value="S"
                    onChange={(newValue) => handleChange("indGrupoEconomico", newValue)}
                    isChecked={data?.indGrupoEconomico}
                    hasError= {validacion.indGrupoEconomico && '*'} 
                >
                    Si
                </Radio>
                <Radio
                    id="indGrupoEconomico"
                    name="indGrupoEconomico"
                    value="N"
                    onChange={(newValue) => {
                                            data.indGrupoEconomico=newValue;
                                            validacion.indGrupoEconomico=false;
                                            handleChange("indGrupoEconomico", newValue);
                                            handleChange("grupoEconomico", []);}} 
                    isChecked={data?.indGrupoEconomico}
                    hasError= {validacion.indGrupoEconomico && '*'}                           
                >
                    No
                </Radio>                            
                </div>
            </div>
            {data && data.indGrupoEconomico=='S' && 
            <>
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">
                    <Input
                      label="Denominación Social"
                      name="nombres"
                      maxLength="500"
                      value={dataTempGr?.nombres}
                      onChange={(newValue) => {
                        handleChangeTempGr("nombres", newValue); 
                      }                    
                      }
                      hasError= {validacionTempGr.nombres && '*'}
                      customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                        
                    />
                </div>
              </div>
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">
                    <InputWithDropdown
                      selectProps={{
                        label: "Tipo Documento",
                        selected: dataTempGr && arrTipoDoce.find(obj=>obj.value==dataTempGr.idpTipoDocumento),
                        onChange: (newValue) =>
                          handleChangeTempGr("idpTipoDocumento",  newValue.value),
                        items: arrTipoDoce,
                        classNameList: 'listLarge',
                        hasError: validacionTempGr.idpTipoDocumento && '*'
                      }}
                      inputProps={{
                        label: "Numero de Documento",
                        name: "numeroDocumento",
                        maxLength: "15",
                        value: dataTempGr?.numeroDocumento,
                        customRegex: /^[a-zA-Z0-9]*$/,
                        onChange: (newValue) =>
                          handleChangeTempGr("numeroDocumento", String(newValue)),
                        hasError: validacionTempGr.numeroDocumento && '*'
                      }}
                    />
                </div>
              </div>                  
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">
                  <Select
                    label="Nacionalidad"
                    selected={dataTempGr && arrPais.find(obj=>obj.value==dataTempGr.idPais)}
                    onChange={(newValue) => {handleChangeTempGr("idPais", newValue.value);
                                            }}
                    items={arrPais}
                    filterable = {true}
                    hasError= {validacionTempGr.idPais && '*'}
                  />
                </div>
              </div>                  
              <div className="d-flex-center w100">
                <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                  <div className="documents_btnSearch">
                    <Button
                      // type="submit"
                      primary
                      size="small"
                      onClick={()=>
                              {
                                if(validarFormularioGr())
                                  { if(indiceEditarGr==null || indiceEditarGr==undefined){
                                        data.grupoEconomico.push(dataTempGr);
                                      }else{
                                        data.grupoEconomico[indiceEditarGr]=dataTempGr;
                                      }
                                      setIndiceEditarGr(null);                                   
                                      setDataTempGr({});
                                      handleChange("grupoEconomico", data.grupoEconomico,data.grupoEconomico.length-1 ); 
                                  }                           
                                
                                
                                //
                                //data.listaCuadro.push(dataTempGr);
                                //handleChange("listaCuadro", data.listaCuadro);
                              }
                      }
                    >
                      Agregar Grupo Económico
                    </Button>
                  </div>                  
                </div>
              </div>
            </>
            }
             

            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                <div className="documents_btnSearch">
                  <Button
                    // type="submit"
                    primary
                    size="large"
                    onClick={()=>{
                      if(validarFormularioGeneral()){
                        if(data.representante.length>0 && (data.grupoEconomico.length>0 || data.indGrupoEconomico=='N')){
                          handleActualizarFicha(data);
                          handleChangePaso(keyIndex);
                        }else{
                          if(data.representante.length==0){
                            let valTemp={idpTipoDocumento: true,
                                            numeroDocumento: true,
                                            nombres: true,
                                            indPep: true,
                                            cargo: true,
                                            prcCapital: true,
                                            aniosCargo: true,
                                            idPais: true,
                                            idResPais: true,      
                                            fecNacimiento: true,
                                            profesion: true,
                                            direccion: true,
                                            telefono: true,
                                            correo: true};
                            setValidacionTemp({...valTemp});
                          }
                          if(data.grupoEconomico.length==0){
                            let valTempGr={idpTipoDocumento: true,
                                          numeroDocumento: true,
                                          nombres: true,                            
                                          idPais: true      
                                          };
                            setValidacionTempGr({...valTempGr});
                          }
                        }
                      }
                    }}
                  >
                    Continuar
                  </Button>
                </div>                  
              </div>
            </div>
        </div>
        <div className="proveedores_margen">
          <DatosProveedor data={dataT}/>
          <div className="documents_criteria_datos">
                <Button
                  size="small"                  
                  onClick={() => handleShowModal("PEP")}
                >
                  ¿Ques es PEP?
                </Button>
          </div>
          <div className="documents_criteria_datos">
            <label htmlFor="indAccionista2">
              Agregaste {data.representante.length} Representante Legal.
            </label>                      
            <Button
              size="small"
              iconLeft={
                <img
                  src={addUserIcon}
                  alt="add user logo"
                  height={15}
                  className="margin-right-8"
                />
              }
              onClick={() => handleShowModal("REP")}
            >
              VER REPRESENTANTE LEGAL
            </Button>                    
          </div>
          <div className="documents_criteria_datos">
            <label htmlFor="indAccionista2">
              Agregaste {data.grupoEconomico.length} Grupo Económico.
            </label>                      
            <Button
              size="small"
              iconLeft={
                <img
                  src={addUserIcon}
                  alt="add user logo"
                  height={15}
                  className="margin-right-8"
                />
              }
              onClick={() => handleShowModal("GRP")}
            >
              VER GRUPO ECONOMICO
            </Button>                    
          </div>
        </div>
        <Modal
            className="rd--modal-info-files"
            onToggle={(value) => setInfoModal(false)}
            visible={infoModal}
            width={672}
            fullScreenMobile
            redHoverClosed
            onLabelClosed
            max12Padding
            footer={
              <Button primary onClick={() => setInfoModal(false)}>
                Cerrar
              </Button>
            }
          >
            {tagBody!='PEP'?(tagBody=='REP'?bodyModalRepresentante(tagBody):bodyModalGrupoEconomico(tagBody)):bodyModal(tagBody)}
        </Modal>            
      </div>
  );
};


export default ProveedoresRepresentanteLegal;
